export default __webpack_public_path__ + "static/vignette_collection_2-7c018144448c6b010ccc67ac9e5ac814.png";